import { Link } from "react-router";

interface CompanyLinkProps {
  vendorId: string;
  /** null: the company record is missing. */
  vendor: { companyName: string } | null | undefined;
}

/** The employee's company, linked to its page; "Vendor not on file" when the
 *  company record is missing. */
export function CompanyLink({ vendorId, vendor }: CompanyLinkProps): React.ReactElement {
  if (!vendor) return <span>Vendor not on file</span>;
  return (
    <Link
      to={`/staff/companies/${encodeURIComponent(vendorId)}`}
      className="text-blue-700 hover:text-blue-900 hover:underline"
    >
      {vendor.companyName}
    </Link>
  );
}
